import { render, staticRenderFns } from "./EwayBillPopup.vue?vue&type=template&id=702f2b48&scoped=true&"
import script from "./EwayBillPopup.vue?vue&type=script&lang=js&"
export * from "./EwayBillPopup.vue?vue&type=script&lang=js&"
import style0 from "./EwayBillPopup.vue?vue&type=style&index=0&id=702f2b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f2b48",
  null
  
)

export default component.exports